import React, { useState, useContext } from "react";
import icon__close from "../../../asset/icon/close-icon.svg";
import { ArrowUpTrayIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { CurrentUserContext } from "../../../App";

function ModalUploadMedia({
  titlename,
  showIconClose,
  onClose,
  limitSizeHeight,
  limitSizeWeight,
  placeholder,
  btnsubmitname,
  labelname,
  callbackApi,
}) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [showMediaList, setShowMediaList] = useState([]);
  const [valueInput, setValueInput] = useState([]);
  const [targetFile, setTargetFile] = useState(null);

  const onSelectFile = (e) => {
    if (e !== "") {
      // console.log(e.target.files)
      const uploadFiles = e.target.files;
      setTargetFile(uploadFiles);
      createUrlBlobFile(uploadFiles);
    }
  };

  const createUrlBlobFile = (uploadFiles) => {
    const uploadFilesList = Array.from(uploadFiles);

    const fileData = uploadFilesList.map((file) => {
      return {
        name: file["name"],
        url: URL.createObjectURL(file),
      };
    });
    setShowMediaList(fileData);
  };
  const onClickSaveMedia = () => {
    if (valueInput === "") {
      setIsMessage({ type: "warning", data: `กรุณาใส่${labelname}` });
    } else if (showMediaList.length === 0) {
      setIsMessage({ type: "warning", data: `กรุณาอัปโหลดวิดีโอก่อนบันทึก` });
    } else {
      callbackApi(valueInput, targetFile[0]);
    }
  };
  return (
    <div className="fixed w-full h-full z-20 inset-0 flex justify-center items-center bg-[#0000008f]">
      <div
        className={`${limitSizeWeight ? limitSizeWeight : "w-[600px]"} ${limitSizeHeight ? limitSizeHeight : "w-[500px]"} bg-[#FFFFFF] rounded-3xl`}
      >
        {showIconClose ? (
          <>
            <div className="flex justify-end my-[5px]">
              <img
                onClick={() => {
                  onClose();
                }}
                className="w-[30px] h-[30px] mr-[30px] hover:cursor-pointer"
                src={icon__close}
                alt=""
              />
            </div>
          </>
        ) : null}
        <div className="mt-[20px] px-[30px] pb-[30px]">
          <div className="text-xl font-medium text-center text-[#2E2E2E]">
            {titlename}
          </div>
          <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] my-[25px]"></div>
          <div className="text-[#A2B5BC] font-medium">{labelname}</div>
          <input
            className="border-[2px] border-solid border-[#A2B5BC] rounded-xl text=state-100 text-[#A2B5BC] p-5 focus:outline-none mt-1 mb-4 h-[30px] w-full"
            placeholder={placeholder}
            onChange={(e) => {
              setValueInput(e.target.value);
            }}
            value={valueInput}
          ></input>

          <section className="flex justify-center my-[10px]">
            <label className="button-theme-pg flex justify-center items-center w-48 h-12 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-full gap-1 text-[#526F65] shadow-sm shadow-brand-cyan ">
              <div>อัปโหลดไฟล์</div>
              <ArrowUpTrayIcon className="w-6 stroke-[#526F65] hover:cursor-pointer" />
              <input
                type="file"
                accept="video/*"
                name="images"
                style={{ display: "none" }}
                onChange={(e) => {
                  onSelectFile(e);
                }}
              />
            </label>
          </section>

          {showMediaList.length > 0 ? (
            <>
              {showMediaList.map((i, idx) => (
                <div
                  key={idx}
                  className="flex justify-center items-center gap-1"
                >
                  <div className="text-[#2E2E2E] text-medium text-center ">
                    <video
                      playsInline
                      className="w-[200px] h-[140px]"
                      src={i["url"]}
                    />
                  </div>
                  <div className="relative">
                    <XMarkIcon
                      onClick={() => {
                        onSelectFile("");
                        setShowMediaList([]);
                      }}
                      className="absolute top-[-40px] right-[10px] w-6 stroke-[5px] stroke-[#85DDDE] hover:cursor-pointer"
                    />
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="my-[120px]"></div>
          )}

          <div className="flex justify-center gap-[20px]">
            <button
              className="button-theme-pg flex justify-center items-center w-48 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 text-[#526F65] shadow-sm shadow-brand-cyan "
              onClick={() => {
                onClickSaveMedia();
              }}
            >
              {btnsubmitname}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalUploadMedia;
